import React, { useCallback, useMemo, useRef } from 'react';
import { node } from 'prop-types';

import { PriceSocket } from 'Component/Socket';

/**
 * @type {{ subscribeStock: (code: string) => {}, unsubscribeStock: (code: string) => {} }}
 */
const INITIAL_CONTEXT_VALUE = {
  subscribeStock: () => {},
  unsubscribeStock: () => {},
};

export const PriceSocketContext = React.createContext(INITIAL_CONTEXT_VALUE);

const PriceSocketProvider = ({ children }) => {
  const wsRef = useRef(null);

  const subscribeStock = useCallback((code) => {
    wsRef.current.subscribeStock(code);
  }, []);

  const unsubscribeStock = useCallback((code) => {
    wsRef.current.unsubscribeStock(code);
  }, []);

  // Subscribe on websocket connection open
  const onWebsocketOpen = () => subscribeStock('*');

  const contextProps = useMemo(
    () => ({
      subscribeStock,
      unsubscribeStock,
    }),
    [subscribeStock, unsubscribeStock]
  );

  return (
    <PriceSocketContext.Provider value={contextProps}>
      {children}
      <PriceSocket ref={wsRef} onOpen={onWebsocketOpen} />
    </PriceSocketContext.Provider>
  );
};

PriceSocketProvider.propTypes = {
  children: node.isRequired,
};

export default PriceSocketProvider;
